import { render, staticRenderFns } from "./ReviewBlockForm.vue?vue&type=template&id=1821626a"
import script from "./ReviewBlockForm.vue?vue&type=script&lang=js"
export * from "./ReviewBlockForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports